
<template>
  <div>
    <div>
      <template v-for="(employee, i) in exec_model_1.employees">
        <div :key="i" class="d-flex justify-center">
          <v-card class="my-2" width="500px">
            <v-card-title>
              Colaborador #{{ i+1 }}
              <v-spacer></v-spacer>
              <v-btn v-if="exec_model_1.employees.length > 1" color="error" icon @click="removeEmployee(i)"><v-icon>mdi-delete</v-icon></v-btn>
            </v-card-title>
            <v-card-text>
              <v-text-field label="Nome" v-model="employee.name" :rules="required"></v-text-field>
              <v-checkbox label="Terceirizado" v-model="employee.outsourced"></v-checkbox>
              <v-text-field v-if="employee.outsourced" label="Nome da empresa" v-model="employee.company_name" :rules="required"></v-text-field>
            </v-card-text>
          </v-card>
        </div>
      </template>
    </div>
    <div class="d-flex justify-center pt-2">
      <v-btn color="primary" @click="addEmployee()"><v-icon left>mdi-plus</v-icon>Colaborador</v-btn>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import validations from '@/mixins/validations';

export default {
  name: 'EmployeeList',
  mixins: [ validations ],
  data() {
    return {
      employee: {
        name: '',
        local_ref: null,
        grade_time: [],
        outsourced: false,
        company_name: ''
      },
    }
  },
  mounted () {
    this.addEmployee();
  },
  methods: {
    removeEmployee(idx) {
      this.$swal({
        showConfirmButton: true,
        showCancelButton: true,
        cancelButtonText: 'Não',
        confirmButtonText: 'Sim',
        title: 'Deseja remover o colaborador?',
        icon: 'question'
      }).then(r => {
        if(r.isConfirmed) {
          this.exec_model_1.employees.splice(idx, 1);
        }
      })
    },
    addEmployee() {
      let random_number = this.getRandomIntInclusive();
      this.exec_model_1.employees.push({
        ...this.employee,
        local_ref: random_number
      });
    },
    getRandomIntInclusive() {
      return 12399 + Math.round(this.exec_model_1.employees.length*Math.random()*100)
    },
    ...mapActions({
      // function: 'Module/action'
    })
  },
  computed: {
    ...mapState({
      exec_model_1: state => state.Execution.exec_model_1
    })
  },
  watch: {
    data(nv,ov) {
      if (nv){
      } else if (nv == false){
      }
    }
  },
}
</script>

<style scoped>

</style>